import * as React from "react";
import { styled } from "@mui/material";
import { DemoZoomContent } from "./useDemoReasoningController";
import { usePatient } from "../../../state/patientContext";
import {
  MobileReasoningTopArea,
  MobileReasoningTopTitle,
  ReferencesBox,
  ReferencesButton,
  ReferencesButtonContainer,
} from "./mobileSuggestionReasoningBox";
import { useTranslate } from "../../../hooks/useTranslate";
import { TriageConditionReasoningList } from "./triageConditionReasoningList";

//region [[ Styles ]]

const MobileTriageReasoningBoxView = styled("div")({});

const TriageReasoningContent = styled("div")({
  display: "flex",
  flexFlow: "row",
  justifyContent: "center",
  flexWrap: "wrap",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface MobileTriageReasoningBoxProps extends DemoZoomContent {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const TriageRecommendationReasoning = ({
  ...props
}: MobileTriageReasoningBoxProps) => {
  const { translate } = useTranslate();

  const { conversationDDResult } = usePatient();

  const { navigationRecommendation } = conversationDDResult;

  const triageName = navigationRecommendation?.feature.feature.shortname;

  const title = `Why is Kahun Suggesting ${triageName}?`;

  if (props.desktop && props.setTitle) props.setTitle(title);

  // TODO: sort by urgency
  const rolloutClusters = [
    ...conversationDDResult?.ddClusters?.top,
    ...conversationDDResult?.ddClusters?.others,
  ]
    .sort((a, b) => b.title.urgencyInfo.urgency - a.title.urgencyInfo.urgency)
    ?.slice(0, 2);

  const mostLikelyClusters = conversationDDResult?.ddClusters?.top;

  return (
    <MobileTriageReasoningBoxView>
      {!props.desktop && (
        <MobileReasoningTopArea className={"top-area"}>
          <MobileReasoningTopTitle className={"top-title"}>
            {title}
          </MobileReasoningTopTitle>
        </MobileReasoningTopArea>
      )}
      <ReferencesBox className={"references-box"}>
        <ReferencesButtonContainer>
          {!props.desktop && (
            <ReferencesButton
              label={translate("SHOW_REFERENCES")}
              onClick={props.onReferencesClick}
            />
          )}
        </ReferencesButtonContainer>
      </ReferencesBox>
      <TriageReasoningContent className={"triage-reasoning-content"}>
        <TriageConditionReasoningList
          className={"most-likely"}
          title={"Most likely causes"}
          clusters={mostLikelyClusters}
          desktop={props.desktop}
        />
        <TriageConditionReasoningList
          className={"rollout-conditions"}
          title={"R/O Disorders"}
          clusters={rolloutClusters}
          desktop={props.desktop}
        />
      </TriageReasoningContent>
    </MobileTriageReasoningBoxView>
  );
};
